import React from 'react';
import { makeStyles } from '@material-ui/core';
import { GreshamLogo } from '../../assets';

const useStyles = makeStyles({
  svg: {
    width: '150px', 
    height: '40px',
    objectFit: 'contain',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <img 
      className={classes.svg}
      src={GreshamLogo}
      alt="Gresham Tech Logo"
    />
  );
};
